import qs from 'qs';
import request from '@/utils/request';

// export const login = (username: string, password: string) =>{
//   return request.post(
//     '/connect/token',
//     qs.stringify({
//       client_id: 'api.ams.admin.client',
//       client_secret: 'milOLNKalLa',
//       grant_type: 'password',
//       username: username,
//       password: password
//     })
//   );
// }

export const login = (username: string, password: string, verificationCode?: string) => {
  let params = verificationCode != undefined && verificationCode != '' ? {
    'userName': username,
    'password': password,
    'verificationCode': verificationCode
  } : {
      'userName': username,
      'password': password
    }
  return request.post(
    '/api/Account/SignIn',
    params
  );
}

/**检查是否需要验证码 */
export const checkVerifyCode = (userName: string) => {
  return request.get(
    '/api/Account/checkNeedVerificationCode',
    { 'userName': userName });
};

/**生成验证 */
export const generateVerificationCode = (userName: string) => {
  return request.get(
    '/api/Account/GenerateVerificationCode',
    { 'userName': userName });
};

/**获取登录用户信息 */
export const loginInfo = () => {
  return request.get(
    '/api/Account/LoginInfo',
    {});
};

/**修改手机号码 */
export const modifyPhone = (phone: string, code: string) => {
  let param = {
    'phone': phone,
    'verificationCode': code
  }
  return request.put(
    '/api/Account/Phone',
    param);
}

/**修改密码 */
export const modifyPWD = (oldPassword: string, newPassword: string) => {
  let param = {
    'oldPassword': oldPassword,
    'newPassword': newPassword
  }
  return request.put(
    '/api/Account/Password',
    param);
}

/**修改密码 */
export const modifyName = (name: string) => {
  let param = {
    'name': name
  }
  return request.put(
    '/api/Account',
    param);
}